import React, { Component } from 'react';
import { inViewService } from 'src/services/InViewService';
import { wobblyLineProps } from 'src/pages/slide';
import './WhySlide3.scss';
import Growth from './growth/Growth';
import headAnchors from './anchor-data/head/head';
import brainAnchors from './anchor-data/head/brain';
import { BlobFiller } from 'src/components/blob-filler/BlobFiller';

export class WhySlide3 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      brainIsInView: false
    }
  }

  componentDidMount() {
    inViewService.add({id: 'growth', element: this.refs.growth, onScroll: growthIsInView => this.onScroll(growthIsInView)});
  }

  componentWillUnmount() {
    inViewService.remove('growth');
  }

  onScroll(growthIsInView) {
    this.setState({
      growthIsInView,
    });
  }

  render() {
    console.log()
    return (
      <div className="WhySlide3" {...wobblyLineProps({ color: this.props.color })}>
        <div className="Page-slide">
          <div className="Page-content">
            <p><b>Design Thinking is your pathway to learning and acquiring these skills.</b></p>

            <p>It’s the way we will all do business in the future and it’s the quickest way to demonstrating real value and success.</p>

            <p>Let’s get started.</p>
          </div>
          <div className="Page-image-growth" ref="growth">
            <BlobFiller fills={[{
                anchors: headAnchors,
                x: 10,
                y: 90,
                color: 0xf05a7d,
              },
              {
                anchors: brainAnchors,
                x: 5,
                y: 85,
                color: 0x2d2323,
                alpha: 1,
              }]}
              x={-10} y={0}
              width={200} height={300}
              isInView={this.state.growthIsInView} />
            <Growth isInView={this.state.growthIsInView}></Growth>
          </div>
        </div>
      </div>
    )
  }
}
